import { customAlphabet } from "nanoid";

export const ALPHANUMERIC_UPPERCASE = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
export const generateErrorUID = customAlphabet(ALPHANUMERIC_UPPERCASE, 5);
